import React from 'react'

export const MODAL_ROOT_ID = 'modal-root'

export const ModalRoot = () => <div id={MODAL_ROOT_ID} />
